module.exports = __webpack_public_path__ + "fonts/AkkuratLL-Bold.c2b65465.otf";